import { useCallback } from 'react';
import { useStore } from 'src/stores';
import { isAppfolioFrom } from 'src/pages/ReportingPage/tabsFor';

/** The proxy's enum (lib/turnContext.mjs) and property-service's CustomerType. */
export const BILLING_TYPES = ['AppfolioIntegrated', 'BilledThroughLivable', 'Convergent', 'CableInternet'];
const isBillingType = value => BILLING_TYPES.includes(value);

/**
 * A staff-set customer type when the company store has one, else derived from the live flags in both stores that
 * carry them (see isAppfolioFrom), so a flag change takes effect at once; undefined until either has loaded.
 * Cable/internet has no flag: property-service detects it from the utilities, so a derived CableInternet stands
 * while neither flag is on.
 */
export function billingTypeFrom(company, dashboard) {
  let loaded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!loaded) return undefined;
  if ((company === null || company === void 0 ? void 0 : company.customerTypeSource) === 'set' && isBillingType(company.customerType)) return company.customerType;
  if (isAppfolioFrom(company === null || company === void 0 ? void 0 : company.isAppfolio, dashboard === null || dashboard === void 0 ? void 0 : dashboard.isAppfolio)) return 'AppfolioIntegrated';
  if (company !== null && company !== void 0 && company.convergentBillingMode || dashboard !== null && dashboard !== void 0 && dashboard.convergentBillingMode) return 'Convergent';
  return (company === null || company === void 0 ? void 0 : company.customerType) === 'CableInternet' ? 'CableInternet' : 'BilledThroughLivable';
}

/** A getter, so a turn reads the flags as they are when it is sent rather than when the drawer mounted. */
export function useBillingType() {
  const store = useStore();
  return useCallback(() => {
    var _store$homeDashboardS;
    return billingTypeFrom(store.company.companyFeatureStore, (_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.companyFeatureSet, store.company.getCurrentUserCompanyFromTokenAsync.hasEverBeenRun || Boolean(store.homeDashboardStore.getCurrentCompany));
  }, [store]);
}